import { array, mixed, number, object, string, ObjectSchema } from 'yup';
import { EapLedFunction, eapLedFunction, EapLedPattern } from '../../models/eap';

const eapLedConfigurationSchema = object({
    led: number().integer().min(1).max(16).required().strict(),
    function: mixed<EapLedFunction>().oneOf(Object.values(eapLedFunction)).nullable().optional().strict(),
    alarmGroupId: string().uuid().nullable().optional().strict(),
    dutyRole: string().nullable().optional().strict(),
    manUnman: mixed<'MAN' | 'UNMAN'>().oneOf(['MAN', 'UNMAN']).nullable().optional().strict(),
    onDuty: mixed<'ON_DUTY' | 'NOT_ON_DUTY'>().oneOf(['ON_DUTY', 'NOT_ON_DUTY']).nullable().optional().strict(),
}).test('function-requires-configuration', 'errors.validation.eap.function-configuration-required', config => {
    if (!config?.function) {
        return true;
    }
    switch (config.function) {
        case eapLedFunction.ALARM:
            return !!config.alarmGroupId;
        case eapLedFunction.MAN_UNMAN:
            return !!config.manUnman;
        case eapLedFunction.WHO_DUTY:
            return !!config.dutyRole;
        case eapLedFunction.ON_DUTY:
            return !!config.onDuty;
        case eapLedFunction.ENGINEER_CALL:
            return true;
        default:
            return false;
    }
});

const eapLedPatternConfigurationSchema = object({
    leds: array()
        .of(eapLedConfigurationSchema)
        .required()
        .length(16)
        .test(
            'at-least-one-led',
            'errors.validation.eap.at-least-one-led',
            leds => leds?.some(led => led.function != null) ?? false
        ),
});

export function eapLedPatternValidator(): ObjectSchema<EapLedPattern> {
    return object({
        id: string().uuid().nullable().optional().strict(),
        vesselId: string().uuid().required().strict(),
        name: string().required().strict(),
        pattern: eapLedPatternConfigurationSchema.required().strict(),
    }) as ObjectSchema<EapLedPattern>;
}
